import useTranslator from "../../hooks/useTranslator";

const EmailInput = ({ value, onChange, disabled }) => {
  const { _t } = useTranslator();
  return (
    <div className="main-form-group">
      <div className={`form-group ${false ? "form-group-error" : ""}`}>
        <label>{_t("email")}</label>
        <input
          type="text"
          placeholder={_t("enterEmail", "Text used in onboarding process")}
          name="email"
          onChange={onChange}
          value={value}
          required
          disabled={disabled}
        />
      </div>

      {false && <p className="error-message">{}</p>}
    </div>
  );
};

export default EmailInput;
